import isUndefined from "lodash/fp/isUndefined";
import { saveCanvas } from "../../core/utils";
import { BrowserQRCodeSvgWriter } from "@zxing/library";
import domtoimage from "dom-to-image";

class Controller {
  constructor($injector, $state, $stateParams) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.$state = $state;
    this.Bus = $injector.get("Bus");
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.BusTransforms = $injector.get("BusTransforms");
    this.sections = $injector.get("Sections").fleetSections;
    this.onUpdate = this.Events.getUpdateEvent("bus");
    this.isQRGenerated = false;
    this.isTrackingConfEditable = false;
    this.qrCardBg = "white";
    this.vendorsList = [
      {
        id: "itrackus",
        title: "iTrackUS",
      },
    ];
    this.toggleTrackingConfEditing = () => {
      this.isTrackingConfEditable = !this.isTrackingConfEditable;
    };
    this.updateTrackingConf = () => {
      const { isDisabled, key, ...busTracking } = this.bus.tracking_config;
      this.sendUpdateRequest({
        id: this.$stateParams.id,
        methodName: key,
        updatedItem: { tracking_config: busTracking },
        item: { key, ...busTracking },
        updateMethod: "PUT",
      });
    };

    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;

    this.onUpdateBusAction = (item) => {
      const updatedItem = {};
      updatedItem[item.key] = isUndefined(item.value)
        ? item.name
          ? item.name._id
          : null
        : item.value;

      if (item.key === "year" && item.value !== null) {
        updatedItem[item.key] = `${item.value}`;
      }
      if (
        (item.methodName === "update_owner" ||
          item.methodName === "update_supplier") &&
        item.name === null
      ) {
        updatedItem.owner_type = "unassigned";
      } else {
        updatedItem.owner_type = item.key;
      }

      this.sendUpdateRequest({
        id: this.$stateParams.id,
        methodName: item.methodName,
        updatedItem,
        item,
      });
    };

    this.sendUpdateRequest = (params) => {
      const { id, methodName, updatedItem, item, updateMethod } = params;
      this.Bus.updateAction({
        id,
        name: methodName,
        item: updatedItem,
        updateMethod,
      }).$promise.then(
        (response) => {
          this.bus = this.BusTransforms.justify(response);
          if (item) {
            this.bus[item.key].isDisabled = true;
            this.Events.emit(this.showNotificationEvent, {
              message: `Your bus "${item.key}" has been updated successfully`,
            });
          }
          this.isTrackingConfEditable = false;
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.generateQRCode = () => {
      this.isQRGenerated = true;
      const codeWriter = new BrowserQRCodeSvgWriter();
      document.getElementById("qr-result").innerHTML = "";
      if (this.bus.bus_code) {
        codeWriter.writeToDom(
          "#qr-result",
          this.bus.bus_code.value.toString(),
          300,
          300
        );
      }
    };

    this.downloadQRCode = (quality = 1) => {
      const filename = `bus-qr-${this.bus.plates.value}.png`;
      const node = document.getElementById("bus-qrcode");
      domtoimage
        .toPng(node, { quality, bgcolor: this.qrCardBg })
        .then((dataUrl) => {
          saveCanvas(dataUrl, filename);
        });
    };
  }

  $onInit() {
    this.Bus.get(this.$stateParams.id).$promise.then((response) => {
      this.bus = this.BusTransforms.justify(response);
    });

    this.generateBusCode = () => {
      this.Bus.generateBusCode(this.$stateParams.id)
        .$promise.then(() => {
          this.Events.emit(this.showNotificationEvent, {
            message: "Bus code generated successfully",
          });
          this.$state.go(this.$state.current.name, {}, { reload: true });
        })
        .catch((err) => {
          this.Events.emit(this.errorEvent, { message: err.data.message });
        });
    };

    this.Events.on(this.onUpdate, this.onUpdateBusAction);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bus/bus.controller.js